import TarafKisi from "./parser/TarafKisi";
import TarafKurum from "./parser/TarafKurum";
import TakipRolleri from "./parser/TakipRolleri";
import app from "@/main";

export default class UyapTakipTalebiContent {
    data: any;
    tarafList: Array<TarafKisi | TarafKurum> = [];
    alacakKalemleri: any[] = [];
    takibeEsasMiktar: number = 0;
    hashObj: any;
    hash: string = "";

    static parse(data: any): UyapTakipTalebiContent {
        let UTTC = new UyapTakipTalebiContent();
        UTTC.data = data;
        const alacakliGroup = data?.GroupXfPGrp;
        let alacaklilar: any[] = [];
        if (Array.isArray(alacakliGroup)) {
            alacaklilar = alacakliGroup.map((item: any) => item?.alacakliAdiSoyadiGrp ?? item).filter((item: any) => !!item);
        } else if (alacakliGroup?.alacakliAdiSoyadiGrp) {
            const alacakliRaw = alacakliGroup.alacakliAdiSoyadiGrp;
            alacaklilar = Array.isArray(alacakliRaw) ? alacakliRaw : [alacakliRaw];
        } else if (alacakliGroup) {
            alacaklilar = [alacakliGroup];
        }
        alacaklilar.forEach((alacakli: any) => UTTC.setTarafAlacakli(alacakli));

        const borcluGroup = data?.GroupXgPGrp;
        let borclular: any[] = [];
        if (Array.isArray(borcluGroup)) {
            borclular = borcluGroup.map((item: any) => item?.borcluAdiSoyadiGrp ?? item).filter((item: any) => !!item);
        } else if (borcluGroup?.borcluAdiSoyadiGrp) {
            const borcluRaw = borcluGroup.borcluAdiSoyadiGrp;
            borclular = Array.isArray(borcluRaw) ? borcluRaw : [borcluRaw];
        } else if (borcluGroup) {
            borclular = [borcluGroup];
        }
        borclular.forEach((borclu: any) => UTTC.setTarafBorclu(borclu));
        UTTC.setTakibeEsasMiktar();
        UTTC.createHash();
        return UTTC;
    }

    createHash() {
        let hashObj: any = {
            taraflar: [],
            takibeEsasMiktar: this.takibeEsasMiktar,
        };
        this.tarafList.forEach(taraf => {
            if (taraf.isKisi()) {
                hashObj.taraflar.push({
                    ad: taraf.temelBilgileri.adi,
                    soyad: taraf.temelBilgileri.soyadi,
                    tcKimlikNo: taraf.temelBilgileri.tcKimlikNo,
                    rolId: taraf.tarafSifati.rolID
                })
            }
            if (taraf.isKurum()) {
                hashObj.taraflar.push({
                    kurumadi: taraf.temelBilgileri.kurumAdi,
                    vergino: taraf.temelBilgileri.vergiNo,
                    mersisno: taraf.temelBilgileri.mersisNo,
                    rolId: taraf.tarafSifati.rolID
                })
            }
        });
        this.hashObj = hashObj;
        this.hash = app.$uyapHelper.hash(hashObj);
    }

    setTakibeEsasMiktar() {
        let kalemler = this.data.TabloXeXa.rowXeXa.TabloXbXb.rowXbXb;
        //TODO DOLAR OLABILIR >>
        let toplamYaziliKalem = kalemler.find((x: any) => x.takipTalebiDortMaddFaizinIslemeyeBasladigiGunGrp.faizinIslemeyeBasladigiGun == "TL   Toplam Alacak ");
        this.takibeEsasMiktar = toplamYaziliKalem.takipTalebiDortMaddeAlacaginTlOlarakKarsiligiFaizMiktarGrp.takipTalebiDortMaddeAlacaginTlOlarakKarsiligiFaizMiktari;
    }

    setTarafAlacakli(item: any) {
        let taraf: TarafKisi | TarafKurum;
        if (typeof item.tc_Kimlik != "undefined") {
            taraf = new TarafKisi();
            let adSoyad = item.alacakliAdiSoyadi.trim().trim(" ").replace(",", "");
            let ad = adSoyad.substr(0, adSoyad.lastIndexOf(" "));
            let soyad = adSoyad.substr(adSoyad.lastIndexOf(" "), adSoyad.length).trim();
            let tcKimlikNo = item.tc_Kimlik.substr(0, item.tc_Kimlik.indexOf("TC Nolu,")).trim();
            taraf.temelBilgileri.adi = ad;
            taraf.temelBilgileri.soyadi = soyad;
            taraf.temelBilgileri.tcKimlikNo = tcKimlikNo;
            taraf.adresBilgisi.adres = item.avukatYoksaAlacakliAdresi;
            taraf.kisiMi = true;
        } else {
            taraf = new TarafKurum();
            taraf.kurumMu = true;
            taraf.temelBilgileri.kurumAdi = item.alacakliAdiSoyadi?item.alacakliAdiSoyadi.replace(",", "").trim():"";
            taraf.temelBilgileri.vergiNo = item.vergiNo?item.vergiNo.replace("Vergi Nolu,", "").trim():"";
            taraf.adresBilgisi.adres = item.avukatYoksaAlacakliAdresi;
        }
        //@ts-ignore
        taraf.tarafSifati = new TakipRolleri().find(21);
        this.tarafList.push(taraf);
    }

    setTarafBorclu(item: any) {
        let taraf: TarafKisi | TarafKurum;

        if(typeof item.vergiNo != "undefined"){
            taraf = new TarafKurum();
            taraf.kurumMu = true;
            taraf.temelBilgileri.kurumAdi = item.borcluAdiSoyadi?item.borcluAdiSoyadi.replace(",", "").trim():"";
            taraf.temelBilgileri.vergiNo = item.vergiNo?item.vergiNo.replace("Vergi Nolu,", "").trim():"";
            taraf.adresBilgisi.adres = item.avukatYoksaborcluAdresi;
        }else{
            taraf = new TarafKisi();
            let adSoyad = item.borcluAdiSoyadi.trim().trim(" ").replace(",", "");
            let ad = adSoyad.substr(0, adSoyad.lastIndexOf(" "));
            let soyad = adSoyad.substr(adSoyad.lastIndexOf(" "), adSoyad.length).trim();
            let tcKimlik = item.tc_Kimlik?item.tc_Kimlik:"";
            let tcKimlikNo = tcKimlik.substr(0, tcKimlik.indexOf("TC Nolu,")).trim();
            taraf.temelBilgileri.adi = ad;
            taraf.temelBilgileri.soyadi = soyad;
            taraf.temelBilgileri.tcKimlikNo = tcKimlikNo;
            taraf.adresBilgisi.adres = item.avukatYoksaborcluAdresi;
            taraf.kisiMi = true;
        }

        //@ts-ignore
        taraf.tarafSifati = new TakipRolleri().find(22);
        this.tarafList.push(taraf);
    }

}
